import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SCREEN_TYPE } from 'src/helpers/functions';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-status-renderer',
  templateUrl: './status-renderer.component.html'
})
export class StatusRendererComponent  implements ICellRendererAngularComp {

  params: any;
  label!: string;
  SCREEN_TYPE = SCREEN_TYPE;
  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    this.params = params;
    return true;
  }

  onClick($event: any) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
}
